
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToFeatures = () => {
    const element = document.getElementById('features');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      className="relative min-h-screen flex items-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/cd1e25b848734285621b23fe959a8258.jpg')`
      }}
    >
      <div className="container mx-auto px-4 w-full">
        <div className="max-w-3xl">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
            「ちょこっとハウス」<br />
            <span className="text-orange-400">秋田県湯沢・横手</span>で<br />
            自分らしい暮らしを
          </h1>
          
          <p className="text-xl md:text-2xl text-gray-200 mb-8 leading-relaxed">
            小さく、賢く、自分らしく暮らす<br />
            二人のための住まい
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4">
            <Button 
              size="lg"
              onClick={scrollToContact}
              className="text-lg px-8 py-4"
            >
              <i className="ri-file-text-line mr-2"></i>
              資料請求・無料相談はこちら
            </Button>
            
            <Button 
              variant="outline"
              size="lg"
              onClick={scrollToFeatures}
              className="text-lg px-8 py-4 bg-white/10 border-white text-white hover:bg-white hover:text-gray-900"
            >
              詳しく見る
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
